import { render, staticRenderFns } from "./SalesCardOverview.vue?vue&type=template&id=29134114&scoped=true"
import script from "./SalesCardOverview.vue?vue&type=script&lang=js"
export * from "./SalesCardOverview.vue?vue&type=script&lang=js"
import style0 from "./SalesCardOverview.vue?vue&type=style&index=0&id=29134114&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29134114",
  null
  
)

export default component.exports